export default __webpack_public_path__ + "static/media/spotify.9bdbcda3.png";